/**
 * Hide the Recharge subscription widget on product pages.
 *
 * This script is only loaded when the widget must be suppressed — i.e. the
 * `enable_subscription_widget` theme setting is off, or the customer is B2B.
 * It covers Recharge Active Flow injection, which adds the widget to the DOM
 * after page load and bypasses the theme app-block render.
 */
(function () {
  "use strict";

  function hideWidget() {
    document
      .querySelectorAll("recharge-subscription-widget")
      .forEach(function (el) {
        el.style.setProperty("display", "none", "important");
      });

    document.querySelectorAll(".shopify-app-block").forEach(function (el) {
      if (el.querySelector("recharge-subscription-widget")) {
        el.style.setProperty("display", "none", "important");
      }
    });
  }

  hideWidget();

  if (typeof MutationObserver !== "undefined") {
    new MutationObserver(hideWidget).observe(document.body, {
      childList: true,
      subtree: true,
    });
  }
})();
